import { Zap, Download, Shield, Lock } from "lucide-react";

const badges = [
  {
    icon: Zap,
    title: "Sofort",
    description: "In 2 Min."
  },
  {
    icon: Download,
    title: "Unbegrenzt",
    description: "Lebenslang"
  },
  {
    icon: Shield,
    title: "Sicher",
    description: "SSL"
  },
  {
    icon: Lock,
    title: "DSGVO",
    description: "Konform"
  }
];

const GuaranteeBadges = () => {
  return (
    <div className="grid grid-cols-4 gap-2">
      {badges.map((badge, index) => {
        const Icon = badge.icon;
        return (
          <div
            key={index}
            className="text-center p-2 rounded-xl bg-card/50 border border-primary/10 hover:border-primary/30 shadow-soft hover:shadow-hover transition-all duration-300 group hover-lift"
          >
            <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-primary/10 flex items-center justify-center group-hover:bg-primary/20 transition-all duration-300">
              <Icon className="w-5 h-5 text-primary group-hover:scale-110 transition-transform duration-300" />
            </div>
            <div className="font-semibold text-foreground text-xs leading-tight">
              {badge.title}
            </div>
            <div className="text-[10px] text-muted-foreground leading-tight mt-0.5">
              {badge.description}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GuaranteeBadges;
